import { render, staticRenderFns } from "./GeneralLoader.vue?vue&type=template&id=808fbaf8"
import script from "./GeneralLoader.vue?vue&type=script&lang=js"
export * from "./GeneralLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports